import { useContext, useEffect, useState } from 'react'
import CircularProgress from '../CircularProgress'
import use3DViewerEvent from '../../hooks/use3DViewerEvent'
import { AppConfigContext } from '../../context/AppConfig'

export function ModelLoaderProgress({ progress, className = '' }) {
  const [displayedProgress, setDisplayedProgress] = useState(0)
  const {isOfficesApp} = useContext(AppConfigContext)
  use3DViewerEvent('model-loading-progress', ({ payload }) => {
    setDisplayedProgress(Math.ceil(payload.progress))
  })

  return (
    <div className={`${className}`}>
      <div className={` flex items-center fade-in`}>
      {' '}
      <div className="h-[16px] w-[16px] mr-[8px]">
        <CircularProgress value={displayedProgress} />
      </div>{' '}
      <div className="text-[12px] lg:text-[14px] font-medium text-[#3D4256]">
        Loading Models <span className="opacity-50 lg:opacity-80">({displayedProgress.toFixed()}%)</span>
      </div>
    </div>
    </div>
  )
}
